module.exports = __webpack_public_path__ + "static/img/loading.f440472.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sack/loading.gif
// module id = csC5
// module chunks = 1